import React from 'react'
import DashboardHeader from '../Integration/DashboardHeader'
import SuplierDash from '../Integration/SuplierDash'
import FormSupplierFacturas from '../Integration/FormSupplierFacturas'

export default function PageSupplierFacturas() {
  return (


    <div>

        <DashboardHeader/>
        <SuplierDash/>
        <FormSupplierFacturas/>


    </div>
  )
}
